/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_OverlineInputs */

const bn_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পর্কে`)
};

const de_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um`)
};

const el_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για`)
};

const en_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const es_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fr_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const hi_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के बारे में`)
};

const hu_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körülbelül`)
};

const id_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const it_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di`)
};

const ja_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`について`)
};

const ko_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에 대한`)
};

const nl_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

const pl_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O`)
};

const pt_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const ru_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О`)
};

const sv_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const tr_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const uk_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`про`)
};

const vi_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về`)
};

const zh_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const zh_hant_about_overline = /** @type {(inputs: About_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {About_OverlineInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const about_overline = /** @type {((inputs?: About_OverlineInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_OverlineInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_about_overline(inputs)
	if (locale === "de") return de_about_overline(inputs)
	if (locale === "el") return el_about_overline(inputs)
	if (locale === "en") return en_about_overline(inputs)
	if (locale === "es") return es_about_overline(inputs)
	if (locale === "fr") return fr_about_overline(inputs)
	if (locale === "hi") return hi_about_overline(inputs)
	if (locale === "hu") return hu_about_overline(inputs)
	if (locale === "id") return id_about_overline(inputs)
	if (locale === "it") return it_about_overline(inputs)
	if (locale === "ja") return ja_about_overline(inputs)
	if (locale === "ko") return ko_about_overline(inputs)
	if (locale === "nl") return nl_about_overline(inputs)
	if (locale === "pl") return pl_about_overline(inputs)
	if (locale === "pt") return pt_about_overline(inputs)
	if (locale === "ru") return ru_about_overline(inputs)
	if (locale === "sv") return sv_about_overline(inputs)
	if (locale === "tr") return tr_about_overline(inputs)
	if (locale === "uk") return uk_about_overline(inputs)
	if (locale === "vi") return vi_about_overline(inputs)
	if (locale === "zh") return zh_about_overline(inputs)
	return zh_hant_about_overline(inputs)
});